var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logoimg}})]),_c('div',{staticClass:"nav"},[_c('ul',_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.funyuming(item.url)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }